function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .red-thumb-down{fill:#e80000;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "red-thumb-down",
  d: "M0,24.4H3.093a1.031,1.031,0,0,0,1.031-1.031V12.031A1.031,1.031,0,0,0,3.093,11H0Z",
  transform: "translate(20.106 -11)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "red-thumb-down",
  d: "M6.993,14.021a4.124,4.124,0,0,0,3.133,1.443h6.7v5.155c0,2.274.819,4.124,3.093,4.124a1.031,1.031,0,0,0,.995-.76L24.044,13.4V0H11.233A4.1,4.1,0,0,0,7.157,3.5L6.047,10.714A4.124,4.124,0,0,0,6.993,14.021Z",
  transform: "translate(-6 0)"
});

var SvgThumbDownRed = function SvgThumbDownRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.229,
    height: 24.743,
    viewBox: "0 0 24.229 24.743",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbDownRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumb-down-red.3802a3ff.svg";
export { ForwardRef as ReactComponent };